import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import "./App.css";
import NotFound from "./components/404";
import MobileRedirect from "./components/pages/MobileRedirect";

import "antd/dist/antd.css";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Navbar from "./components/elements/navbar";
import LayoutBecome from "./components/layouts/layout-become";
import LayoutBlog from "./components/layouts/layout-blog";
import LayoutCart from "./components/layouts/layout-cart";
import LayoutChefFood from "./components/layouts/layout-chef-food";
import Layout from "./components/layouts/layout-home";
import LayoutHomeChef from "./components/layouts/layout-home-chef";
import LayoutIamChef from "./components/layouts/layout-iam-chef";
import LayoutSuccessGlocery from "./components/layouts/layout-order-glocery-success";
import LayoutSuccess from "./components/layouts/layout-order-success";
import LayoutUserOrders from "./components/layouts/layout-user-orders";
import LayoutUserProfile from "./components/layouts/layout-user-profile";
import CrispWeb from "./components/menus/crisp";
import Footer from "./components/menus/footer";
import UnderMaintenance from "./components/under-maintenance-modern";
import { useAuthRestore } from "./hooks/useAuthRestore";
import { useLanguage } from "./hooks/useLanguage";

import { GET } from "./components/constants/request-type";
import { service_api } from "./components/constants/url";
import { MakeRequestAsync } from "./components/functions/axios";
import { decryptSingleData } from "./components/functions/cryptojs";
import LayoutAboutus from "./components/layouts/layout-aboutus";
import LayoutTerms from "./components/layouts/layout-terms";
import { POST_SETTING } from "./store/action";

import { useDispatch } from "react-redux";
import LayoutAcademy from "./components/layouts/layout-academy";
import LayoutCareer from "./components/layouts/layout-career";
import LayoutFoodSafety from "./components/layouts/layout-food-safety";
import LayoutTermsService from "./components/layouts/layout-terms-service";

import { FEATURE_FLAGS } from "./components/constants/featureFlags";
import { createLogger } from "./utils/logger";

const logger = createLogger("App");

function App() {
  const [search, setSearch] = useState("");
  
  const setting = useSelector((state) => state.setting);

  // Initialize language system
  useLanguage();

  // Restore authentication from localStorage
  useAuthRestore();

  const dispatch = useDispatch();
  useEffect(() => {
    initialData();
  }, []);

  const Setting = (value) => dispatch(post_setting(value));
  const onSearch = (value) => setSearch(value);

  const initialData = async () => {
    const request_details_chef = {
      type: GET,
      url: service_api,
      route: `country/get-one-by-country/+1`,
      token: null
    };

    try {
      const response = await MakeRequestAsync(request_details_chef);
      const decryptedData = await decryptSingleData(response.data.country);
      Setting(decryptedData);
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  return (
    <div className="App">
      <Router>
        <div style={{ height: "80px" }}>
          <Navbar 
            onSearch={(text) => onSearch(text)}
            textValue={search}
            landing={true}
          />
        </div>
        <Switch>
          <Route exact path="/">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <Layout />
          </Route>
          <Route exact path="/become-a-chef">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutBecome />
          </Route>
          <Route exact path="/explore/chef">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutHomeChef />
          </Route>
          <Route exact path="/user/profile">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutUserProfile />
          </Route>
          <Route exact path="/user/orders">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutUserOrders />
          </Route>
          <Route exact path="/order/chef/menu">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutChefFood />
          </Route>
          <Route exact path="/order/chef/menu/cart">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutCart />
          </Route>
          <Route exact path="/order/sucessful/complete">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutSuccess />
          </Route>
          <Route exact path="/chef/iam-a-chef/home">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/cuisine">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/address">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/profil">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/cooking-delivery-day">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/order">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/menu">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/edit-menu">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/add-menu">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/order">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/glocery">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/order-glocery/sucessful/complete">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutSuccessGlocery />
          </Route>
          <Route exact path="/chef/iam-a-chef/withdrawal">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/banking">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          {FEATURE_FLAGS.blogEnabled && (
            <Route exact path="/chef/iam-a-chef/blog">
              {setting?.general?.maintenance === true && (
                <Redirect to="/under-maintenance" />
              )}
              <LayoutIamChef />
            </Route>
          )}
          <Route exact path="/chef/iam-a-chef/hub">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          <Route exact path="/chef/iam-a-chef/help">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef />
          </Route>
          {FEATURE_FLAGS.blogEnabled && (
            <Route exact path="/blog">
              {setting?.general?.maintenance === true && (
                <Redirect to="/under-maintenance" />
              )}
              <LayoutBlog />
            </Route>
          )}
          <Route exact path="/support-crisp-webview">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <CrispWeb />
          </Route>
          <Route exact path="/terms-of-service">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutTermsService />
          </Route>
          <Route exact path="/privacy-policy">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutTerms />
          </Route>
          <Route exact path="/community-guidelines">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutTerms />
          </Route>
          <Route exact path="/food-safety">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutFoodSafety />
          </Route>
          <Route exact path="/our-story">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutAboutus />
          </Route>
          <Route exact path="/careers">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutCareer />
          </Route>
          <Route exact path="/panichefs-academy">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutAcademy />
          </Route>
          <Route exact path="/chef/iam-a-chef/certificate">
            {setting?.general?.maintenance === true && (
              <Redirect to="/under-maintenance" />
            )}
            <LayoutIamChef setting={setting} />
          </Route>
          <Route exact path="/under-maintenance">
            {setting?.general?.maintenance === false && <Redirect to="/" />}
            <UnderMaintenance setting={setting} />
          </Route>
          <Route exact path="/mobile-redirect">
            <MobileRedirect />
          </Route>
          <Route exact path="*">
            <NotFound />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;

const post_setting = (data) => ({
  type: POST_SETTING,
  data: data
});
